import { useMemo } from 'react'
import { Box, Table } from '@mantine/core'

import { TableList } from '@/modules/employerUsers/pages/components/TableList/TableList'
import { TableTitle } from '@/modules/employerUsers/pages/components/TableTitle/TableTitle'

import { Loader } from '@/components/Loader/Loader'
import { ScrollArea } from '@/components/ScrollArea/ScrollArea'

import { useEmployerUsersServiceEmployerUsersControllerGetAllEmployees } from '@/__generated__/queries'

import classes from './UsersTable.module.css'

export function UsersTable() {
  const { data, isFetching, isLoading } =
    useEmployerUsersServiceEmployerUsersControllerGetAllEmployees()

  const users = useMemo(() => {
    if (!data) {
      return []
    }

    return data
  }, [data])

  if (isFetching || isLoading) {
    return <Loader isMinimized />
  }

  return (
    <Box className={classes.table}>
      <ScrollArea scrollbars="x">
        <Table>
          {!!users.length && <TableTitle />}
          <TableList items={users} />
        </Table>
      </ScrollArea>
    </Box>
  )
}
